import script from "./AppCoVersionSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppCoVersionSelect.vue?vue&type=script&setup=true&lang=ts"

import "./AppCoVersionSelect.vue?vue&type=style&index=0&id=5ed39c82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed39c82"]])

export default __exports__